import { AsyncPipe, CommonModule, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { HasRolePipe } from '../../pipes/has-role.pipe';

import { ProfileFacadeService } from '@sh/facades/profile-facade.service';
import { map } from 'rxjs';
import { AuthService } from '@sh/services/auth/auth.service';
import { ThemeService } from '@sh/theme/services/theme.service';
import { ShareComponent } from '../share/share.component';
import { GlobalSearchStateService } from '@sh/services/global-search-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    AsyncPipe,
    ShareComponent,
    CommonModule,
    RouterModule,
    HasRolePipe,
  ],
})
export class HeaderComponent {
  menuOpen = false;
  resourceMenuOpen = false;
  closeMenuOnNavigation(event: MouseEvent) {
    if ((event.target as HTMLElement).closest('a')) this.menuOpen = false;
  }

  profile$ = this.profileFacade.profile$;
  avatarImage$ = this.profile$.pipe(
    map((profile) => {
      if (profile?.avatarJsonData && profile.avatarJsonData !== '{}') {
        try {
          const avatarData = JSON.parse(profile.avatarJsonData);
          return avatarData.avatarImage || 'batguy.webp';
        } catch (e) {
          return 'batguy.webp';
        }
      }
      return 'batguy.webp';
    }),
  );
  darkModeEnabled = this.themeService.darkModeEnabled;
  shareMessage = 'Check out Study Heroes';
  showDownloadButtons = false;
  readonly resourceTypes$ = this.searchStateService.resourceTypes$;
  readonly languages = [
    { code: 'all', name: 'All Languages' },
    { code: 'za', name: 'South Africa' },
    { code: 'us', name: 'United States' },
    { code: 'gb', name: 'United Kingdom' },
    { code: 'au', name: 'Australia' },
  ];
  selectedLanguage = 'All Languages';
  selectedLanguageCode = 'all';

  constructor(
    private profileFacade: ProfileFacadeService,
    public auth: AuthService,
    private themeService: ThemeService,
    private router: Router,
    private searchStateService: GlobalSearchStateService,
  ) {
    this.searchStateService.searchState$.subscribe((state) => {
      this.selectedLanguage =
        this.languages.find((language) => language.code === state.country)
          ?.name ?? 'All Languages';
      this.selectedLanguageCode = state.country;
    });
  }

  //TODO
  toggleDarkMode() {
    return this.themeService.toggleDarkMode();
  }

  toggleSideDrawer() {
    var checkbox = document.getElementById('side-drawer') as HTMLInputElement;
    if (checkbox) {
      checkbox.checked = !checkbox.checked;
    }
  }

  toggleDownloadButtons() {
    this.showDownloadButtons = !this.showDownloadButtons;
  }

  openAppModal() {
    const modal = document.getElementById('links_modal') as HTMLDialogElement;
    if (modal) {
      modal.showModal();
    }
  }

  filterByResourceType(resourceType: string) {
    this.searchStateService.updateSearchState({
      query: '',
      categories: [],
      tags: [],
      resourceTypes: [resourceType],
    });
    this.closeResourceMenu();
    this.router.navigate(['/search']);
  }

  showAllMedia() {
    this.searchStateService.updateSearchState({
      query: '',
      categories: [],
      tags: [],
      resourceTypes: [],
    });
    this.closeResourceMenu();
    this.router.navigate(['/search']);
  }

  selectLanguage(code: string, menu: HTMLDetailsElement) {
    this.searchStateService.updateSearchState({ country: code, locales: [] });
    menu.open = false;
  }

  closeLanguageMenu(menu: HTMLDetailsElement) {
    menu.open = false;
  }

  closeDropdownMenu(menu: HTMLDetailsElement) {
    menu.open = false;
  }

  closeDropdownMenuOnBlur(event: FocusEvent, menu: HTMLDetailsElement) {
    const nextTarget = event.relatedTarget as Node | null;
    if (!nextTarget || !menu.contains(nextTarget)) {
      this.closeDropdownMenu(menu);
    }
  }

  closeResourceMenu() {
    this.resourceMenuOpen = false;
    this.menuOpen = false;
  }

  closeResourceMenuOnBlur(event: FocusEvent) {
    const nextTarget = event.relatedTarget as Node | null;
    if (!nextTarget || !(event.currentTarget as HTMLElement).contains(nextTarget)) {
      this.resourceMenuOpen = false;
    }
  }

  // Remove the shareVia method as it's now handled by the ShareComponent
}
